import { memo } from 'react';
import { Flex, Text } from '@chakra-ui/react';

import { BUILDER_MODE_V1_LAYOUT, BUILDER_MODE_V1_TOKENS } from '../../constants';

export interface InputTypeTabOption {
  value: string;
  label: string;
}

export interface InputTypeTabGroupV1Properties {
  options: InputTypeTabOption[];
  activeValue: string;
  isDisabled?: boolean;
  onChange: (value: string) => void;
}

const InputTypeTabGroupV1 = memo(
  ({ options, activeValue, isDisabled = false, onChange }: InputTypeTabGroupV1Properties) => (
    <Flex
      w='100%'
      gap='1px'
      p='0'
      border='1px solid'
      borderColor={BUILDER_MODE_V1_TOKENS.border}
      borderRadius={BUILDER_MODE_V1_LAYOUT.inputTypeTabRadius}
      bg={BUILDER_MODE_V1_TOKENS.white}
      overflow='hidden'
      flexShrink={0}
    >
      {options.map((option) => {
        const isActive = activeValue === option.value;

        return (
          <Flex
            key={option.value}
            as='button'
            type='button'
            role='tab'
            aria-selected={isActive}
            disabled={isDisabled}
            flex='1 1 0'
            minW={0}
            h={BUILDER_MODE_V1_LAYOUT.inputTypeTabHeight}
            px={BUILDER_MODE_V1_LAYOUT.inputTypeTabPaddingX}
            py='8px'
            align='center'
            justify='center'
            borderRadius={BUILDER_MODE_V1_LAYOUT.inputTypeTabRadius}
            bg={isActive ? BUILDER_MODE_V1_TOKENS.textDark : 'transparent'}
            cursor={isDisabled ? 'not-allowed' : 'pointer'}
            opacity={isDisabled ? 0.6 : 1}
            onClick={() => {
              if (!isDisabled) onChange(option.value);
            }}
            _hover={
              isDisabled
                ? undefined
                : {
                    bg: isActive
                      ? BUILDER_MODE_V1_TOKENS.textDark
                      : BUILDER_MODE_V1_TOKENS.activeBg,
                  }
            }
          >
            <Text
              fontFamily={BUILDER_MODE_V1_LAYOUT.toolbarFontFamily}
              fontSize={BUILDER_MODE_V1_LAYOUT.inputTypeTabFontSize}
              fontWeight='500'
              lineHeight='normal'
              color={isActive ? BUILDER_MODE_V1_TOKENS.white : BUILDER_MODE_V1_TOKENS.textDark}
              whiteSpace='nowrap'
              textAlign='center'
            >
              {option.label}
            </Text>
          </Flex>
        );
      })}
    </Flex>
  ),
);

InputTypeTabGroupV1.displayName = 'InputTypeTabGroupV1';

export default InputTypeTabGroupV1;
